import MobileViewCompanyInfoContainer from "./Containers/MobileViewCompanyInfoContainer";
export default MobileViewCompanyInfoContainer;
